const concatArray = (arr) => {
	if (arr.length === 0) {
		return '';
	}
	return arr.map((item) => item + '=1');
};

const removeDuplicates = (arr) => {
	const keyGroups = new Map();

	arr.forEach((item) => {
		const match = item.match(/^([^=]+)=(.*)$/);
		if (match) {
			const [_, key, value] = match;

			if (!keyGroups.has(key)) {
				keyGroups.set(key, []);
			}

			// Разбиваем и очищаем значения
			const values = (value || '')
				.split(',')
				.map((val) => val.trim())
				.filter((val) => val);

			values.forEach((val) => {
				keyGroups.get(key).push(val);
			});
		} else {
			keyGroups.set('other_' + Date.now(), [item]);
		}
	});

	const result = [];
	keyGroups.forEach((values, key) => {
		if (key.startsWith('other_')) {
			result.push(...values);
		} else {
			// ТОЛЬКО 2 разных числа, хотя бы одно ≠0
			const rangeFields = ['age', 'price', 'height', 'weight'];
			if (rangeFields.includes(key)) {
				const numbers = values
					.filter((val) => /^\d+$/.test(val) || val === '0') // парсим числа
					.map(Number)
					.filter((n) => n >= 0) // только неотрицательные
					.sort((a, b) => a - b);

				const uniqueRange = [...new Set(numbers)].slice(0, 2); // уникальные, max 2

				// ровно 2 РАЗНЫХ, хотя бы одно >0
				if (
					uniqueRange.length === 2 &&
					uniqueRange[0] !== uniqueRange[1] && // разные
					(uniqueRange[0] > 0 || uniqueRange[1] > 0) && // хотя бы одно ≠0
					uniqueRange[0] < uniqueRange[1]
				) {
					result.push(`${key}=${uniqueRange.join(',')}`);
				}
			}

			// уникальные строки через запятую
			else if (
				[
					'gender',
					'orient',
					'lips',
					'penis',
					'hair',
					'breast',
					'hair_len',
					'intim_hs',
					'eyes',
					'smoking',
					'tattoo',
					'piercing',
					'services',
					'for',
					'language',
					'ethnos',
					'nationality',
					'last_visit',
					'place',
				].includes(key)
			) {
				const uniqueGenders = [...new Set(values)].sort().join(',');
				if (uniqueGenders) {
					result.push(`${key}=${uniqueGenders}`);
				}
			}

			// radius
			else if (key === 'radius') {
				result.push(`radius=${values.join(',')}`);
			}

			// else if (key === 'place') {
			// 	result.push(`place=${values.join(',')}`);
			// }

			// только первое вхождение (status=1)
			else {
				const firstValue = values[0];
				if (firstValue) {
					result.push(`${key}=${firstValue}`);
				}
			}
		}
	});

	return result;
};

const concatenateArrayWithTitle = (arr, title) => {
	const concatenatedString = title + '=' + arr.join(',');
	return concatenatedString;
};

const formatRange = (obj, title) => {
	const { min, max } = obj;
	return `${title}=${min},${max}`;
};

export const buildFilterParams = (
	filters,
	defaults,
	params = '',
	allowedWords = [],
	buildFilters = false,
) => {
	const result = [];
	const urlParams = [];
	const url_filters = {
		service_type: [],
		gender: [],
		status: [],
		ethnos: [],
		hair: [],
		services: [],
	};

	try {
		if (!filters) {
			return { result, urlParams, url_filters };
		}

		// URL фильтры
		const hasUrlFilters = params;
		if (!!hasUrlFilters && hasUrlFilters !== '') {
			const urlSegments = params.split('-');

			urlSegments.forEach((segment) => {
				if (allowedWords.includes(segment)) {
					console.log(`=> check the segment: `, segment);
					if (segment === 'blondes') {
						url_filters.hair.push('blond');
						result.push('hair=blond');
					} else if (segment === 'asian') {
						url_filters.ethnos.push('asian');
						result.push('ethnos=asian');
					} else if (
						segment === 'escort' ||
						segment === 'incall' ||
						segment === 'outcall'
					) {
						// console.log(`=> check the segment push: `, segment);
						url_filters.service_type.push(segment);
						result.push(`place=${segment}`);
					} else if (
						['guys', 'girls', 'couple', 'trans'].includes(segment)
					) {
						switch (segment) {
							case 'guys': {
								url_filters.gender.push('male');

								result.push('gender=male');
								break;
							}
							case 'girls': {
								url_filters.gender.push('female');

								result.push('gender=female');
								break;
							}
							case 'couple': {
								url_filters.gender.push('couple');

								result.push('gender=couple');
								break;
							}
							default: {
								url_filters.gender.push(segment);
								result.push(`gender=${segment}`);
								break;
							}
						}
					} else if (segment === 'massage') {
						url_filters.service_type.push(segment);
						result.push(`${segment}=1`);
					} else if (segment === 'anal') {
						url_filters.services.push(segment);
						result.push(`services=2`);
					} else {
						url_filters.status.push(segment);
						result.push(`${segment}=1`);
					}
				}
			});
		}

		if (buildFilters) {
			const fields = Object.entries(url_filters);

			fields.forEach((value) => {
				let key = value[0];
				const values = filters[key];
				if (values && values.length > 0) {
					values.forEach((value) => {
						url_filters[key].push(value);
					});
				}
			});
		}

		// Range фильтры
		const rangeKeys = ['age', 'weight', 'height', 'price'];
		if (filters?.ranges) {
			try {
				rangeKeys.forEach((key) => {
					const current = filters.ranges.current_state[key];
					const def = defaults?.[key];

					const isModified =
						(current.min !== def.min || current.max !== def.max) &&
						def.max !== 0;

					if (isModified) {
						const formatted = formatRange(current, key);
						// console.log('//////////////');
						// console.log(`=> CURRENT: `, current, key);
						// console.log(`=> DEFAULT: `, def, key);
						// console.log(`=> FORMATTED: `, formatted);
						// console.log('//////////////');

						result.push(formatted);
					}
				});
			} catch (e) {
				console.error(`=> ERR PRASING RANGES: `, e);
			}
		}

		// Простые списки (concatArray)
		const simpleArrayFields = ['status', 'appearance'];

		simpleArrayFields.forEach((key) => {
			try {
				const arr = filters[key];
				if (arr?.length > 0) {
					result.push(...concatArray(arr));
					if (key !== 'appearance') {
						urlParams.push(...arr);
					}
				}
			} catch (e) {
				console.error(e, filters[key], key);
			}
		});

		// Списки с префиксом
		const prefixedLists = [
			[filters.services, 'services'],
			[filters.gender, 'gender'],
			[filters.orientation, 'orient'],
			[filters.ethnos, 'ethnos'],
			[filters.lips, 'lips'],
			[filters.penis, 'penis'],
			[filters.hair, 'hair'],
			[filters.breast, 'breast'],
			[filters.hair_len, 'hair_len'],
			[filters.intim_hs, 'intim_hs'],
			[filters.eyes, 'eyes'],
			[filters.smoking, 'smoking'],
			[filters.tattoo, 'tattoo'],
			[filters.piercing, 'piercing'],
			[filters.for, 'for'],
			[filters.languages, 'languages'],
			[filters.nationality, 'nationality'],
			[filters.last_visit, 'last_visit'],
			[filters.min_time, 'min_time'],
		];

		prefixedLists.forEach(([arr, title]) => {
			if (arr?.length > 0) {
				const formatted = concatenateArrayWithTitle(arr, title);
				result.push(formatted);

				if (title === 'gender') {
					urlParams.push(...filters.gender);
				}
				if (title === 'ethnos' && filters.ethnos.includes('asian')) {
					urlParams.push('asian');
				}
				if (title === 'hair' && filters.hair.includes('blond')) {
					urlParams.push('blondes');
				}
				if (title === 'services' && filters.services.includes('2')) {
					urlParams.push('anal');
				}
			}
		});

		// Radius
		if (filters.radius.value.length > 0) {
			const radiusParam = `radius=${filters.radius.latitude},${
				filters.radius.longitude
			},${filters.radius.value.join(',')}`;
			result.push(radiusParam);
		}

		// Place
		if (filters.service_type.length > 0) {
			const filter_place = filters.service_type.filter(
				(i) => i !== 'massage',
			);
			result.push(concatenateArrayWithTitle(filter_place, 'place'));
			urlParams.push(...filters.service_type);

			// console.log(
			// 	`=> CHECK MASSAGE PRESENCE: `,
			// 	filters.service_type.includes('massage'),
			// 	filters.service_type.some((i) => i === 'massage'),
			// );
			// massage handling separated
			if (filters.service_type.includes('massage')) {
				result.push('massage=1');
			}
		}

		// appearance parsing
		if (Object.values(filters.appearance).some((i) => i.length > 0)) {
			//
		}
	} catch (e) {
		console.error(e);
	} finally {
		return { result: removeDuplicates(result), urlParams, url_filters };
	}
};
